var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInternationalPassportFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 122,
  height: 139,
  viewBox: "0 0 122 139",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-public/img/icons/documents/international_passport_filled.svg__filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 25,
  width: 42,
  height: 53.4545,
  rx: 4,
  fill: "#005FF9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.8756 49.4086C56.8756 49.4086 55.146 48.5391 53.9735 47.9507C53.7289 47.8274 53.5586 47.5944 53.5147 47.3248C53.4719 47.0551 53.5607 46.7803 53.754 46.5869C53.915 46.425 54.0728 46.2682 54.1982 46.1428C54.3643 45.9766 54.5922 45.8857 54.8273 45.893L57.8235 45.9871L59.2688 44.5418L53.6892 41.1422C53.4687 41.0074 53.3214 40.7785 53.29 40.5204C53.2597 40.2633 53.3485 40.0062 53.5314 39.8223C53.6735 39.6812 53.8136 39.5412 53.9327 39.4221C54.1344 39.2204 54.4239 39.1336 54.704 39.1921L62.4917 41.3188L65.2987 38.5118C65.9811 37.8294 67.0899 37.8294 67.7724 38.5118C68.4548 39.1942 68.4548 40.303 67.7724 40.9855L64.9654 43.7925L67.092 51.5802C67.1506 51.8603 67.0638 52.1498 66.8621 52.3515C66.743 52.4706 66.6029 52.6106 66.4619 52.7528C66.2779 52.9356 66.0209 53.0245 65.7638 52.9942C65.5056 52.9628 65.2768 52.8155 65.142 52.595L61.7424 47.0154L60.2981 48.4597L60.3964 51.4506C60.4037 51.6858 60.3138 51.9146 60.1477 52.0808C60.0212 52.2072 59.8613 52.3671 59.6972 52.5302C59.5039 52.7235 59.2291 52.8123 58.9594 52.7695C58.6898 52.7256 58.4568 52.5552 58.3334 52.3107L56.8756 49.4086Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 54.2842,
  y: 67.0454,
  width: 14.25,
  height: 2.59091,
  rx: 1.29545,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 51.2842,
  y: 61.8638,
  width: 19.4318,
  height: 2.59091,
  rx: 1.29545,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46 23.4959H75.2577L75.2508 23.4469C74.9451 21.259 72.9236 19.7332 70.7357 20.039L46 23.4959Z",
  fill: "#005FF9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/icons/documents/international_passport_filled.svg__filter0_d",
  x: 0,
  y: 0,
  width: 122,
  height: 138.455,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgInternationalPassportFilled as ReactComponent };